import React from 'react';
import { useSelector } from 'react-redux';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export default function NextSteps() {

    const nextStepText = useSelector((state) => state.auth.missionDetails.nextSteps);

    return (
        nextStepText && nextStepText.length > 0 ? <div className="next-steps">
            <Row >
                <Col className="next-step-title">
                    Next Steps
                </Col>
            </Row>
            <Row >
                <Col className="next-step-text">
                    {nextStepText}
                </Col>
            </Row>
        </div> :
            null
    );
}
